/** Shared receipt/deadline contract; transport and session cleanup stay with each platform. */
(function(root, factory) {
    const api = factory();
    if (typeof module === 'object' && module.exports) module.exports = api;
    else root.MalkaPasswordChange = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
    'use strict';
    const unconfirmed = 'The password change was not confirmed. Try signing in with your new password before trying again.';
    const confirmed = 'Password updated. You have been signed out on all devices. Sign in with your new password.';
    async function requestPasswordChange(send, signal) {
        if (signal?.aborted) throw new Error(unconfirmed);
        const controller = new AbortController();
        let rejectAbort;
        const interrupted = new Promise((_, reject) => { rejectAbort = reject; });
        const abort = () => { controller.abort(); rejectAbort(new Error(unconfirmed)); };
        signal?.addEventListener('abort', abort, { once: true });
        const timeout = setTimeout(abort, 30000);
        try {
            let response;
            try { response = await Promise.race([send(controller.signal), interrupted]); }
            catch { throw new Error(unconfirmed); }
            if (controller.signal.aborted || !response || !Number.isInteger(response.status)
                    || response.status < 200 || response.status >= 500) throw new Error(unconfirmed);
            if (response.status >= 400) {
                throw new Error(typeof response.error === 'string' && response.error.trim()
                    ? response.error : 'The password change was rejected. Check your current password and try again.');
            }
            if (response.status >= 300 || response.error || response.data?.success !== true) throw new Error(unconfirmed);
            return { success: true };
        } finally {
            clearTimeout(timeout);
            signal?.removeEventListener('abort', abort);
        }
    }
    return { requestPasswordChange, confirmed, unconfirmed };
});
